class Advice {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-advice="scope"]',
			check: '[data-advice="check"]',
			collapse: '[data-advice="collapse"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('change', this.config.check, this.toggleCollapse.bind(this));
	}

	toggleCollapse(event) {
		let $input = $(event.currentTarget);

		if($input.is(':checked')) {
			this.open($input);
		} else {
			this.close($input);
		}
	}

	open($input) {
		let $collapse = $input.closest(this.config.scope).find(this.config.collapse);
		let collapse = bootstrap.Collapse.getOrCreateInstance($collapse[0]);
		collapse.show();
		$collapse.find(':input').attr('disabled', false);
	}

	close($input) {
		let $collapse = $input.closest(this.config.scope).find(this.config.collapse);
		let collapse = bootstrap.Collapse.getOrCreateInstance($collapse[0]);
		collapse.hide();
		$collapse.find(':input').attr('disabled', true);
	}
}

export default new Advice;